import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarSwitch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m16.875 2.5h-1.875v-1.25c0-.66406-.58591-1.25-1.25-1.25-.70309 0-1.25.58594-1.25 1.25v1.25h-5v-1.25c0-.66406-.58594-1.25-1.25-1.25-.70313 0-1.25.58594-1.25 1.25v1.25h-1.875c-1.0547 0-1.875.85937-1.875 1.875v1.875h17.5v-1.875c0-1.0156-.85936-1.875-1.875-1.875zm-15.625 15.625c0 1.0547.82031 1.875 1.875 1.875h13.75c1.0156 0 1.875-.82027 1.875-1.875v-10.625h-17.5z",
		fill: "current",
		strokeWidth: .90909
	})]
});
const ForwardRef = forwardRef(SvgCalendarSwitch);
export { ForwardRef as ReactComponent };
